/**
 * Created by vladislav on 09.02.2022
 */

const DailyTaskTimer = cleverapps.Layout.extend({
    ctor: function (onFinish, onBg) {
        const styles = cleverapps.styles.DailyTaskTimer;

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("DailyTasksWindow.TimeToRefresh"),
            onBg ? cleverapps.styles.FONTS.DAILY_TASK_CTA : cleverapps.styles.FONTS.DAILY_TASKS_TIMER_TEXT
        );
        text.fitTo(styles.text.width);

        const timer = new Timer(cleverapps.dailyTasks.getTimeLeft(), onFinish);

        this._super([text, timer], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        this.setCascadeOpacityEnabled(true);
        timer.setCascadeOpacityEnabled(true);
        timer.y += styles.offsetY;
    }
});

cleverapps.styles.DailyTaskTimer = {
    margin: 20,

    offsetY: 0,

    text: {
        width: 450
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DAILY_TASKS_TIMER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_BROWN
    }
});
